import { pxArrayToRem, pxToRem, type StyleRule } from '@archipro-design/aria';
import EditorConfig from './editor-config';

const NON_SCALING_CONTENT_FONTSIZE = '16px';

export const RichTextEditorNodeStyling: StyleRule = ({ theme }) => {
    const linkStyles = {
        color:
            theme.siteVariables.bodyColor ||
            theme.siteVariables.colors.charcoal['250'],
        textDecoration: 'underline',
    };
    return {
        color:
            theme.siteVariables.bodyColor ||
            theme.siteVariables.colors.charcoal['250'],
        fontSize: pxToRem(16),
        lineHeight: theme.siteVariables.lineHeightSmall,

        [theme.screen.laptop]: {
            fontSize: NON_SCALING_CONTENT_FONTSIZE,
        },

        [`& .${EditorConfig.theme.text.bold}`]: {
            fontWeight: theme.siteVariables.textStyles.Text.Medium65.fontWeight,
        },
        [`& .${EditorConfig.theme.text.italic}`]: {
            fontStyle: 'italic',
        },
        [`& .${EditorConfig.theme.text.underline}`]: {
            textDecoration: 'underline',
        },
        [`& .${EditorConfig.theme.link}`]: {
            ...linkStyles,
            '&span': linkStyles,
            '&strong': linkStyles,
            '&i': linkStyles,
            '&em': linkStyles,
        },
        [`& a.${EditorConfig.theme.link}:link`]: {
            ...linkStyles,
        },
        [`& .${EditorConfig.theme.heading.h2}`]: {
            textAlign: 'center',
            fontSize: pxToRem(24),
            lineHeight: theme.siteVariables.lineHeightSmallest,
            letterSpacing: theme.siteVariables.letterSpacingMedium,
            ...theme.siteVariables.getTextStyle('Medium65', 'Article'),
            [theme.screen.laptop]: {
                fontSize: pxToRem(30),
                lineHeight: theme.siteVariables.lineHeightSmaller,
                letterSpacing: theme.siteVariables.letterSpacingSmall,
            },
        },
        [`& .${EditorConfig.theme.heading.h3}, & .${EditorConfig.theme.heading.h4}`]:
            {
                marginBottom: theme.siteVariables.spaces['space-28'],
                fontSize: pxToRem(20),
                lineHeight: 1.6,
                ...theme.siteVariables.textStyles.Text.Medium65,
                [theme.screen.laptop]: {
                    fontSize: pxToRem(24),
                },
            },
        [`& .${EditorConfig.theme.quote}`]: {
            margin: pxArrayToRem([30, 0]),
            padding: pxArrayToRem([40, 0]),
            fontSize: theme.siteVariables.fontSizes.label01,
            lineHeight: theme.siteVariables.lineHeightSmallest,
            letterSpacing: theme.siteVariables.letterSpacingMedium,
            borderTop: `1px solid ${theme.siteVariables.bodyColor}`,
            borderBottom: `1px solid ${theme.siteVariables.bodyColor}`,
            width: '100%',

            [theme.screen.laptop]: {
                margin: pxArrayToRem([40, 0]),
                fontSize: theme.siteVariables.fontSizes['subheading03-alt'],
                letterSpacing: theme.siteVariables.letterSpacingSmall,
                lineHeight: theme.siteVariables.lineHeightSmaller,
            },

            '&:has(span)::before': {
                content: 'open-quote',
            },
            '&:has(span)::after': {
                content: 'close-quote',
            },
        },
        // Reset styles after Tailwind CSS preflight.
        '& ul, & menu': {
            listStyle: 'disc',
            paddingLeft: '40px',
            marginBottom: pxToRem(16),
        },
        '& ol': {
            listStyle: 'decimal',
            paddingLeft: '40px',
            marginBottom: pxToRem(16),
        },
        '& p': {
            marginBottom: pxToRem(16),
        },
        '& > *:last-child': {
            marginBottom: 0,
        },
    };
};
